import dynamic from 'next/dynamic';

import { HotelGalleryTileProps } from './HotelGalleryTitle.types';

export const HotelGalleryTitle = dynamic<HotelGalleryTileProps>(() =>
  import('./HotelGalleryTitle').then(module => module.HotelGalleryTitle)
);
